import Column from '@components/Column';
import { EventResponse } from '@models/event';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    event: EventResponse;
}

function EventContent({ event }:Props) {
    const { content } = event;
    const { i18n: { language } } = useTranslation();
    return (
        <Column fullWidth>
            <div className={styles.wrapper}
                lang={language}
                dangerouslySetInnerHTML={{ __html: content }}/>
        </Column>
    );
}

export default EventContent;
